module.exports = __webpack_public_path__ + "img/bg_make_01.1fb6b705.png";